import React from 'react';
import { CheckCircle } from 'lucide-react';
import { usePurchaseNotifications } from '../hooks/usePurchaseNotifications';
export const PurchasePopup: React.FC = () => {
  const {
    notification,
    isVisible
  } = usePurchaseNotifications();
  if (!notification) return null;
  return <div className={`
        fixed bottom-4 right-4 z-50 max-w-sm w-full bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4
        transform transition-all duration-500 ease-in-out
        ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'}
      `} data-id="element-83">
      <div className="flex items-start" data-id="element-84">
        <div className="flex-shrink-0" data-id="element-85">
          <CheckCircle className="h-6 w-6 text-green-500" data-id="element-86" />
        </div>
        <div className="ml-3 w-0 flex-1 pt-0.5" data-id="element-87">
          <p className="text-sm font-medium text-gray-900" data-id="element-88">
            ¡Nueva compra verificada!
          </p>
          <p className="mt-1 text-sm text-gray-500" data-id="element-89">
            <span className="font-semibold" data-id="element-90">{notification.name}</span> de{' '}
            {notification.city} acaba de adquirir el MegaPack Música.
          </p>
        </div>
      </div>
    </div>;
};